/* --------------------------------------------------------------------------------------
   xwActionbar.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwActionBar {
  /*@ngInject*/
  constructor (appSettings) {
    this.restrict = 'A'
    this.appSettings = appSettings
    this.scope = {
      labelWidth: '<',
      labelPadding: '<',
      wordWrap: '<',
      faultTheme: '<'
    }
  }
  link(scope, elem, attrs) {
    const options = {
      label: attrs.label,
      widgetSize: attrs.widgetSize,
      theme: attrs.theme? attrs.theme : this.appSettings.primaryColor,
      themePrimary: attrs.hasOwnProperty('themePrimary'),
      labelLineTwo: attrs.labelLineTwo,
      labelWidth: scope.labelWidth,
      labelPadding: scope.labelPadding,
      buttonLeft: attrs.buttonLeft,
      buttonLeftTwo: attrs.buttonLeftTwo,
      buttonRight: attrs.buttonRight,
      buttonRightTwo: attrs.buttonRightTwo,
      wordWrap: scope.wordWrap,
      faultTheme: scope.faultTheme
    }
    elem.first().xrxactionbar(options)
  }
  static directiveFactory(appSettings) {
    xwActionBar.instance = new xwActionBar(appSettings)
    return xwActionBar.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwActionbar.directive.js